const options = {
  5: "bg-teal-400/5",
  10: "bg-teal-400/10",
  25: "bg-teal-400/25",
  50: "bg-teal-400/50",
  75: "bg-teal-400/75",
  90: "bg-teal-400/90",
  100: "bg-teal-400",
};

const from = {
  5: "from-teal-400/5",
  10: "from-teal-400/10",
  25: "from-teal-400/25",
  50: "from-teal-400/50",
  75: "from-teal-400/75",
  90: "from-teal-400/90",
  100: "from-teal-400",
};

export default function getBackgroundTeal400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
